import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isNumberValid, isValueEntered } from 'services/Validation';

export const inputFields = (data, portfolios, handleUserInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
                <h3 className="card-heading">{<IntlMessages id="label.portfolio" />}</h3>
                <Input
                    type="select"
                    name="portfolioId"
                    id="portfolioSelect"
                    onChange={(event) => handleUserInput(event)}
                    value={data?.portfolioId}
                >
                    <option key='emptySelect' value=''>-- select portfolio --</option>
                    {portfolios.map((portfolio) => {
                        return <option key={portfolio.id} value={portfolio.id}>{portfolio.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.budget" />}</h3>
                <Input id="budget" type="text" className={`form-control mb-2 ${data?.buget ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event, true)}
                    defaultValue={data?.budget} name="budget"
                />
                <h3 className="card-heading">{<IntlMessages id="label.valueProposition" />}</h3>
                <Input id="valueProposition" type="text" className={`form-control mb-2 ${data?.valueProposition ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.valueProposition} name="valueProposition"
                />
                <h3 className="card-heading">{<IntlMessages id="label.kpi" />}</h3>
                <Input id="kpi" type="text" className={`form-control mb-2 ${data?.kpi ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.kpi} name="kpi"
                />
                <h3 className="card-heading">{<IntlMessages id="label.systems" />}</h3>
                <Input id="systems" type="text" className={`form-control mb-2 ${data?.systems ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.systems} name="systems"
                />
                <h3 className="card-heading">{<IntlMessages id="label.owner" />}</h3>
                <Input id="owner" type="text" className={`form-control mb-2 ${data?.owner ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.owner} name="owner"
                />
                <h3 className="card-heading">{<IntlMessages id="label.theme" />}</h3>
                <Input id="theme" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.theme} name="theme"
                />
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedValueStream) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedValueStream?.thumb || 'assets/images/valueStreams-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};

export const isFormValid = (selectedValueStream) => {
    return isValueEntered(selectedValueStream?.name) &&
    isValueEntered(selectedValueStream?.valueProposition) &&
    isValueEntered(selectedValueStream?.kpi) &&
    isValueEntered(selectedValueStream?.systems) &&
    isValueEntered(selectedValueStream?.owner) &&
    isNumberValid(selectedValueStream?.budget);
};

export const getFormError = (fieldName, value) => {
    let formError = '';
    switch (fieldName) {
        case 'name':
        case 'valueProposition':
        case 'kpi':
        case 'systems':
        case 'owner':
            formError = isValueEntered(value) ? '' : ' is invalid';
            break;
        case 'budget':
            formError = isNumberValid(value) ? '' : ' is invalid. It must be a number';
            break;
        default:
            break;
    }
    return formError;
};


// WEBPACK FOOTER //
// ./components/Agile/valueStream/valueStreamMaintenance/common.js